/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Occurrence_HistoricalInputs */

const en_us2_profile_editors_pain_occurrence_historical = /** @type {(inputs: Profile_Editors_Pain_Occurrence_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I had it, it's gone`)
};

const pt_br2_profile_editors_pain_occurrence_historical = /** @type {(inputs: Profile_Editors_Pain_Occurrence_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já tive, não dói mais`)
};

const es_419_profile_editors_pain_occurrence_historical = /** @type {(inputs: Profile_Editors_Pain_Occurrence_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo tuve, ya no duele`)
};

const pt_pt2_profile_editors_pain_occurrence_historical = /** @type {(inputs: Profile_Editors_Pain_Occurrence_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já tive, já não dói`)
};

const fr_fr2_profile_editors_pain_occurrence_historical = /** @type {(inputs: Profile_Editors_Pain_Occurrence_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J'en ai eu, c'est passé`)
};

const de_de2_profile_editors_pain_occurrence_historical = /** @type {(inputs: Profile_Editors_Pain_Occurrence_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hatte ich, ist weg`)
};

const it_it2_profile_editors_pain_occurrence_historical = /** @type {(inputs: Profile_Editors_Pain_Occurrence_HistoricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'ho avuto, è passato`)
};

/**
* | output |
* | --- |
* | "I had it, it's gone" |
*
* @param {Profile_Editors_Pain_Occurrence_HistoricalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_occurrence_historical = /** @type {((inputs?: Profile_Editors_Pain_Occurrence_HistoricalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Occurrence_HistoricalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_occurrence_historical(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_occurrence_historical(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_occurrence_historical(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_occurrence_historical(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_occurrence_historical(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_occurrence_historical(inputs)
	return en_us2_profile_editors_pain_occurrence_historical(inputs)
});
export { profile_editors_pain_occurrence_historical as "profile-editors.pain_occurrence_historical" }